import React, { Component } from 'react';
import AuthService from "./AuthService";
import {Link, Redirect} from "react-router-dom";

export default function withAuth(AuthComponent) {

    return class AuthWrapped extends Component {

        constructor(props) {
            super(props);
            this.state = {
                authToken: null,
                showAuthError: false,
                keyboardRedirect: null, // TODO: This isn't part of auth, but we only want functionality when authed... Refactor later
            }
        }

        componentWillMount() {
            if (!AuthService.isLoggedIn()) {
                this.props.history.replace('/login');
            } else {
                if(localStorage.getItem('s-stage') != "sc"){
                    this.props.history.replace('/reset/in');
                }
            }
            this.setState({
                authToken: AuthService.getToken()
            });
        }

        componentDidMount() {
            let pathname = this.props.location != undefined ? this.props.location.pathname: '';
            
            // if((pathname == '/admintools' || pathname == '/admintools/') && !AuthService.isAdmin()){
            //     this.props.history.replace('/');
            // }
            // if((pathname == '/new-store' || pathname == '/new-store/') && !AuthService.isAdmin()){
            //     this.props.history.replace('/');
            // }
            document.addEventListener('keydown', this._handleKeyDown);
        }

        componentWillUnmount() {
            document.removeEventListener('keydown', this._handleKeyDown);
        }

        _onSessionExpired = () => {
            AuthService.logout();
            this.setState({
                showAuthError: true
            },()=>{
                sessionStorage.removeItem('store-name');
                sessionStorage.removeItem('globals_au');
                sessionStorage.removeItem('globals_nz');
                sessionStorage.removeItem('store-admins');
            });
        };

        _handleKeyDown = (event) => {
            // Do nothing if input selected
            if ($('input:focus, textarea:focus, select:focus').length > 0) {
                return;
            }
            // Handle redirects
            let pathname = null;
            switch (event.key) {
                case 'h':
                    pathname = '/';
                    break;
                case 'g':
                    pathname = '/giftcards';
                    break;
                case 'm':
                    pathname = '/members';
                    break;
                case 'n':
                    pathname = '/new-member';
                    break;
                default:
                    break;
            }
            if (pathname === null || pathname === this.props.location.pathname) {
                return;
            }
            event.preventDefault();
            this.setState({
                keyboardRedirect: pathname,
            });
        };

        render() {
            if (!this.state.authToken) {
                return null;
            }
            if (this.state.keyboardRedirect !== null) {
                return <Redirect to={this.state.keyboardRedirect} />
            }
            return (
                <div>
                    <AuthComponent authToken={this.state.authToken} sessionExpired={this._onSessionExpired} {...this.props} />
                    {this.state.showAuthError && <div id="session-expired">

                        <div className="vertab">
                            <div className="vertab--inner viewport">
                                <div className="container container--modal padding--100">

                                    <div className="bg--white padding--90 padding--100--left padding--100--right text--18 text--center">
                                        <img src="/img/icon-alert--orange.svg" alt="" width="81" height="73" className="icon margin--30--bot" />
                                        <h3 className="text--light text--26 text--orange margin--10--bot">Session expired</h3>
                                        <p className="margin--20--bot">Sorry, your session has expired. Please log back in and try again.</p>

                                        <Link to="/login" className="btn btn--large btn--dark">Return to login</Link>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>}

                </div>
            )
        }
    }
}
